import React from 'react';
const LogoZillowPride = () => {
  return (
    <svg id="LogoZillowPride" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 162 34">
      <title id="zillowLogo">Zillow Pride Logo</title>
      <path
        className="cls-1"
        d="M123.79,12.7h6.59l1.91,6.23c.64,2.07,1.7,5.95,1.7,5.95a.05.05,0,0,0,.1,0s1.1-4,1.73-5.95l2-6.23h4.86l2,6.23c.66,2.14,1.69,5.95,1.69,5.95s.08.05.11,0,1.06-3.86,1.7-5.95l1.91-6.23h6.13l-6.63,20.61h-6l-1.64-5.18c-.63-2-1.74-6-1.74-6a.05.05,0,0,0-.1,0s-1.11,3.87-1.78,5.94l-1.67,5.22h-6.14Z"
      />
      <rect className="cls-1" x="79.41" y="1.8" width="6.67" height="31.5" />
      <rect className="cls-1" x="91.02" y="1.8" width="6.67" height="31.5" />
      <path
        className="cls-1"
        d="M117,23.07a4.83,4.83,0,1,0-9.63,0,4.83,4.83,0,1,0,9.63,0m-16,0A11.22,11.22,0,1,1,112.24,34,10.94,10.94,0,0,1,101,23.07"
      />
      <path
        className="cls-1"
        d="M40.81,4.72V10.8H52.6c.06,0,.07,0,0,.08L40.81,31a1.81,1.81,0,0,0-.36,1.16v1.18h23V27.25H50.66a0,0,0,0,1,0-.08l12-20.36A1.52,1.52,0,0,0,62.79,6V4.72Z"
      />
      <path
        className="cls-1"
        d="M67.68,12.7h6.67V33.31H67.68ZM71,2.37A3.78,3.78,0,0,1,74.8,6.11a3.8,3.8,0,0,1-7.59,0A3.79,3.79,0,0,1,71,2.37"
      />
      <path
        className="cls-1"
        d="M160.64,9.76a1,1,0,0,0-1-1h-1.06v2.88h.48v-.86h.46l.53.86h.54L160,10.7A1,1,0,0,0,160.64,9.76Zm-1,.58h-.56V9.18h.56a.58.58,0,0,1,0,1.16Z"
      />
      <path
        className="cls-1"
        d="M159.51,7.75A2.49,2.49,0,1,0,162,10.24,2.49,2.49,0,0,0,159.51,7.75Zm0,4.5a2,2,0,1,1,2-2A2,2,0,0,1,159.51,12.25Z"
      />
      <polygon className="cls-2" points="30.48 22.3 30.48 33.31 27.65 33.31 27.65 22.9 30.48 22.3" />
      <polygon className="cls-2" points="30.48 11.98 30.48 16.82 27.63 17.44 27.61 9.72 30.48 11.98" />
      <polygon className="cls-3" points="27.65 22.9 27.65 33.31 24.53 33.31 24.59 23.7 27.65 22.9" />
      <polygon className="cls-3" points="27.61 9.72 27.63 17.44 24.6 18.21 24.58 7.36 27.61 9.72" />
      <polygon
        className="cls-4"
        points="24.58 7.36 24.6 18.21 21.46 19.14 21.46 14.23 23.71 12.38 21.5 9.74 21.48 4.88 24.58 7.36"
      />
      <polygon className="cls-4" points="24.59 23.7 24.53 33.31 21.47 33.31 21.46 24.59 24.59 23.7" />
      <polygon className="cls-5" points="21.48 4.88 21.5 9.74 20.76 8.86 18.34 9.54 18.3 2.39 21.48 4.88" />
      <polygon className="cls-5" points="21.46 24.59 21.47 33.31 18.32 33.31 18.32 25.57 21.46 24.59" />
      <polygon className="cls-5" points="21.46 14.23 21.46 19.14 18.3 20.16 18.3 17.11 21.46 14.23" />
      <polygon className="cls-6" points="18.3 2.39 18.34 9.54 15.15 10.57 15.24 0 18.3 2.39" />
      <polygon className="cls-6" points="18.32 25.57 18.32 33.31 15.15 33.31 15.17 26.66 18.32 25.57" />
      <polygon className="cls-6" points="18.3 17.11 18.3 20.16 15.16 21.27 15.16 20.44 18.3 17.11" />
      <polygon className="cls-7" points="15.24 0 15.15 10.57 11.97 11.75 11.96 2.6 15.24 0" />
      <polygon className="cls-7" points="15.17 26.66 15.15 33.31 11.99 33.31 12 27.89 15.17 26.66" />
      <polygon className="cls-7" points="15.16 20.44 15.16 21.27 14.26 21.57 15.16 20.44" />
      <polygon className="cls-7" points="14.51 15.51 11.99 17.75 11.99 16.46 14.51 15.51" />
      <polygon className="cls-8" points="12 27.89 11.99 33.31 8.94 33.31 8.97 29.24 12 27.89" />
      <polygon className="cls-8" points="11.99 16.46 11.99 17.75 8.99 20.81 8.99 20.73 9.01 17.68 11.99 16.46" />
      <polygon className="cls-8" points="11.96 2.6 11.97 11.75 8.99 12.98 8.95 4.98 11.96 2.6" />
      <polygon points="9.01 17.68 8.99 20.73 8.99 20.81 5.83 24.7 5.84 18.97 9.01 17.68" />
      <polygon points="8.95 4.98 8.99 12.98 5.84 14.34 5.84 7.43 8.95 4.98" />
      <polygon points="8.97 29.24 8.94 33.31 5.84 33.31 5.83 27.19 7.93 29.8 7.99 29.81 8.97 29.24" />
      <polygon className="cls-9" points="5.84 7.43 5.84 14.34 2.97 15.73 3 9.67 5.84 7.43" />
      <polygon
        className="cls-9"
        points="5.84 18.97 5.83 24.7 4.93 26 5.83 27.19 5.84 33.31 3.04 33.31 2.99 20.22 5.84 18.97"
      />
      <polygon className="cls-10" points="2.99 20.22 3.04 33.31 3.01 33.31 0 33.31 0 21.79 2.99 20.22" />
      <polygon className="cls-10" points="3 9.67 2.97 15.73 0.05 17.32 0 17.23 0 12.1 3 9.67" />
    </svg>
  );
};

export default LogoZillowPride;
